// extracted by mini-css-extract-plugin
export var circle = "PricingCardItem-module--circle--9b5ac";
export var container = "PricingCardItem-module--container--3951a";
export var content = "PricingCardItem-module--content--4ee8c";
export var description = "PricingCardItem-module--description--4f5b0";
export var icon = "PricingCardItem-module--icon--d50ab";
export var item = "PricingCardItem-module--item--90ddb";
export var tag = "PricingCardItem-module--tag--55cb2";